import React from 'react'
import PropTypes from 'prop-types'
import { CSVLink } from 'react-csv'
import { DownloadStyles } from './styled'

export const headers = [
  { label: 'PMID', key: 'pmId' },
  { label: 'Registration No.', key: 'reg' },
  { label: 'Branches', key: 'branches' },
  { label: 'CSEID', key: 'cseId' },
  { label: 'Pipe Line ID', key: 'pipelineId' },
  { label: 'Acetrack ID', key: 'acetrackId' }
]

const Download = (props) => {
  const { data } = props
  const updatedData = data.map(({ pmId, reg, branches, cseId, pipelineId, acetrackId }) => {
    return {
      pmId,
      reg,
      branches: branches.join(','),
      cseId,
      pipelineId,
      acetrackId
    }
  })

  return (
    <DownloadStyles>
      <CSVLink data={updatedData} headers={headers} filename='data.csv'>Download Record</CSVLink>
    </DownloadStyles>
  )
}

export default Download

Download.propTypes = {
  data: PropTypes.array
}
